<ion-app>
  <ion-router-outlet [swipeGesture]="false" mode="md"></ion-router-outlet>
</ion-app>